<template>
  <div class="flex flex-col desc-con">
    <div v-for="item in describe" :key="item.id" class="item flex flex-row align-center">
      <span class="label">{{ item.label }}</span>
      <span class="value text-ellipsis">{{ item.value }} </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiagDescribe",
  props: {
    describe: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.desc-con {
  background-color: #f7f8fa;
  padding: 5px 12px;
  border-radius: 4px;

  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: rgb(78, 89, 105);
      margin-right: 32px;
      width: 56px;
    }

    .value {
      font-weight: bold;
      font-size: 14px;
      line-height: 22px;
      max-width: 400px;
    }
  }
}
</style>
